window.requestAnimationFrame = (function(){
return window.requestAnimationFrame  ||
  window.webkitRequestAnimationFrame ||
  window.mozRequestAnimationFrame    ||
  window.oRequestAnimationFrame      ||
  window.msRequestAnimationFrame     ||
  function(callback){
  window.setTimeout(callback, 1000 / 60);
};
})();

if(Function.prototype.name === undefined &&
   Object.defineProperty !== undefined) {
    Object.defineProperty(Function.prototype, "name", {
        get: function() {
            var funcNameRegex = /function\s([^(]{1,})\(/;
            var results = (funcNameRegex).exec((this).toString());
            return (results && results.length > 1) ? results[1].trim() : "";
        },
        set: function(value) {}
    });
}

var agi = agi || {};
agi.expressions = agi.expressions || {};
agi.expressions.Utils = (function() {

    // jQuery equivalent of $.extend
    function extend() {
        for(var i=1; i<arguments.length; i++)
            for(var key in arguments[i])
                if(arguments[i].hasOwnProperty(key))
                    arguments[0][key] = arguments[i][key];
        return arguments[0];
    }

    function executeFunctionByName(functionName, context /*, args */) {
        var args = Array.prototype.slice.call(arguments, 2);
        var namespaces = functionName.split(".");
        var func = namespaces.pop();
        for (var i = 0; i < namespaces.length; i++) {
            context = context[namespaces[i]];
        }
        return context[func].apply(context, args);
    }

    function addClass(elements, classname) {
        for (var i = 0; i < elements.length; i++) {
            var el = elements[i];
            el.classList.add(classname);
        }
    }

    function removeClass(elements, classname) {
        for (var i = 0; i < elements.length; i++) {
            var el = elements[i];
            el.classList.remove(classname);
        }
    }

    /**
     * Automatically add vendor prefixes for CSS3 animation events
     * to make it easier to add callback.
     * e.g.  prefixedEventListener(myEl, 'AnimationEnd', myCallback);
     */
    function prefixedEventListener(element, type, callback) {
        var pfx = ["webkit", "moz", "MS", ""];
        for (var p = 0; p < pfx.length; p++) {
            if (!pfx[p]) type = type.toLowerCase();
            element.addEventListener(pfx[p]+type, callback, false);
        }
    }

    /**
     * This function will add a script tag to the header and attach
     * a load listener to it.
     * e.g.  prefixedEventListener(myEl, 'AnimationEnd', myCallback);
     */
    function loadJavaScriptFile(url, successCallback, errorCallback) {
        var head = document.getElementsByTagName('head')[0];
        var script = document.createElement('script');
        script.src = url;
        script.addEventListener('load', successCallback);
        script.addEventListener('error', errorCallback);
        head.appendChild(script);
    }

    /**
     * This function will add a style link to the header
     * from the provided URL.
     */
    function loadCSSFile(url, successCallback, errorCallback) {
        var head = document.getElementsByTagName("head")[0];
        var link = document.createElement("link");
        link.addEventListener('load', successCallback);
        link.addEventListener('error', errorCallback);
        link.type = "text/css";
        link.href = url;
        link.rel = "stylesheet";
        head.appendChild(link);
    }

    return {extend: extend,
            addClass: addClass,
            removeClass: removeClass,
            prefixedEventListener: prefixedEventListener,
            executeFunctionByName: executeFunctionByName,
            loadCSSFile: loadCSSFile,
            loadJavaScriptFile: loadJavaScriptFile}
})();
